import React from "react";
import { motion } from "framer-motion";

const HERO_IMG = "/hero_tombstone.png";

/**
 * GraveLight Studio hero — uses the AI-generated tombstone illustration
 * with a soft amber ambient glow and a gentle float animation.
 */
export default function TombstoneScene() {
  return (
    <div className="hero-scene relative" data-testid="hero-tombstone-scene">
      {/* Ambient amber lantern glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(480px 420px at 70% 42%, rgba(251,191,36,0.22), transparent 65%), radial-gradient(360px 320px at 30% 60%, rgba(74,222,128,0.06), transparent 70%)",
          filter: "blur(2px)",
        }}
      />

      <motion.img
        src={HERO_IMG}
        alt="GraveLight Studio tombstone illustration with a small goblin peeking from the side and an old vintage lantern hanging from a classic graveyard pole."
        className="w-full h-full object-contain relative"
        style={{ filter: "drop-shadow(0 30px 60px rgba(0,0,0,0.6))" }}
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.1, ease: "easeOut" }}
        data-testid="hero-tombstone-image"
      />

      {/* Subtle floating motion */}
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{ y: [0, -6, 0] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
  );
}
